import React from 'react';
import { Utensils } from 'lucide-react';
import './Combos.css';

const Combos = () => {
  const combos = [
    {
      name: 'Thaali Meal (Lunch)',
      category: 'Sri Lanka Jaffna Style',
      description: 'Rice, chicken curry, mutton piratal, dal curry, katharikai poriya (fried brinjal), fried fish, rasam, curd, sweet, appalam, salt dry chilli, mixed pickle',
      price: '£15.99',
    },
    {
      name: 'Puttu With Crab Curry',
      category: 'Special Combo',
      description: 'Traditional steamed rice cake served with flavorful crab curry',
      price: '£16.99',
    },
    {
      name: 'Parotta (2) & Bone Curry',
      category: 'Combo Deal',
      description: 'Two fluffy parottas served with your choice of bone curry',
      options: [
        { type: 'Goat Meat', price: '£13.99' },
        { type: 'Chicken', price: '£10.99' },
        { type: 'Mutton', price: '£13.99' },
      ],
    },
  ];

  return (
    <section id="combos" className="combos-section">
      <div className="combos-container">
        <div className="combos-header animate-fade-in-up">
          <h2 className="section-title">Special Combos</h2>
          <div className="title-divider"></div>
          <p className="section-subtitle">Complete meals that bring the best of our cuisine together</p>
        </div>

        <div className="combos-grid">
          {combos.map((combo, index) => (
            <div key={index} className="combo-card hover-lift">
              <div className="combo-icon">
                <Utensils size={32} />
              </div>
              <div className="combo-category">{combo.category}</div>
              <h3 className="combo-name">{combo.name}</h3>
              <p className="combo-description">{combo.description}</p>
              
              {combo.options ? (
                <div className="combo-options">
                  {combo.options.map((option, idx) => (
                    <div key={idx} className="combo-option">
                      <span className="option-type">{option.type}</span>
                      <span className="option-price">{option.price}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="combo-price">{combo.price}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Combos;